import { useState } from 'react';
import OrgAdminLayout from '../components/OrgAdminLayout';
import { Card } from '../../design-system';
import SmartSearch from '../../components/command/SmartSearch';
import AskAi from '../../components/command/AskAi';
import CommandBar from '../../components/command/CommandBar';
import CommandHistory from '../../components/command/CommandHistory';
import '../../components/command/CommandBar.css';

// The AI section: find things, or tell the app to do something.
//
// ⚠️ THREE TABS, AND THEY ARE THREE DIFFERENT ACTS. Search FINDS, Ask
// EXPLAINS, Command WRITES. Collapsing them into a single omnibox is the
// obvious product instinct and it is wrong here: a box that sometimes answers
// and sometimes creates a task means every sentence carries a risk the user has
// to think about before pressing Enter. Search leads because it is the one
// people reach for twenty times a day and it can do no damage; Command is the
// deliberate third click, behind a confirmation.
//
// ⚠️ RENDERS OrgAdminLayout LIKE EVERY OTHER COCKPIT PAGE. App.jsx applies no
// layout — each page wraps itself — and the layout is also where
// `canAccessNavKey(user, requiredNavKeyFor(pathname))` runs. A cockpit page
// that skips it loses the sidebar AND its route guard.
//
// ⚠️ THE HISTORY IS THE SERVER'S, NOT THIS COMPONENT'S. Both tabs used to keep
// what had happened in React state — the Ask thread in `AskAi`, the confirmed
// commands in a `done` array here — so a refresh emptied both while the
// database held the rows all along (`AiMessage` did not exist; `CommandLog`
// did, unread). `done` survives only as a nudge that makes a command just
// confirmed appear before the next fetch returns.
export default function OrgAdminAi() {
  const [tab, setTab] = useState('search');
  const [done, setDone] = useState([]);

  return (
    <OrgAdminLayout
      title="AI"
      subtitle="Search everything, ask a question, or type an instruction. Nothing is created until you confirm."
    >
      <Card>
        <div className="cmd-modes cmd-tabs" role="tablist">
          <button
            type="button" role="tab" aria-selected={tab === 'search'}
            className={`cmd-mode${tab === 'search' ? ' is-on' : ''}`}
            onClick={() => setTab('search')}
          >
            Search
          </button>
          <button
            type="button" role="tab" aria-selected={tab === 'ask'}
            className={`cmd-mode${tab === 'ask' ? ' is-on' : ''}`}
            onClick={() => setTab('ask')}
          >
            Ask
          </button>
          <button
            type="button" role="tab" aria-selected={tab === 'command'}
            className={`cmd-mode${tab === 'command' ? ' is-on' : ''}`}
            onClick={() => setTab('command')}
          >
            Command
          </button>
        </div>

        {tab === 'search' && <SmartSearch />}
        {tab === 'ask' && <AskAi />}
        {tab === 'command' && <CommandBar onDone={(result) => setDone((d) => [result, ...d])} />}
      </Card>

      {tab === 'command' && (
        <Card>
          <Card.Header
            title="Command history"
            subtitle="Everything you have typed here, and what each one did."
          />
          {/* One sentence can set a dozen fields, so each row names what its
              command actually did — read off the stored result, not re-derived
              from the intent. */}
          <CommandHistory justNow={done} />
        </Card>
      )}
    </OrgAdminLayout>
  );
}
